import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/colors';

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Header = styled.header`
  padding: 8px 24px;
  display: flex;
  align-items: center;
`;

const LogoImage = styled.img`
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px 24px;
  margin-top: 24px;
`;

const Footer = styled.footer`
  padding: 16px;
  text-align: center;
  font-size: 14px;
  color: #68878D;
`;

const Layout = ({ children }) => {
  return (
    <LayoutContainer>
      <Header>
        <LogoImage src="/logo.svg" alt="RECEPTIONIST" />
      </Header>
      <MainContent>{children}</MainContent>
      <Footer>© RECEPTIONIST, Inc.　All Rights Reserved</Footer>
    </LayoutContainer>
  );
};

export default Layout;
